var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRosa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 283.754,
    cy: 335.259,
    r: 64.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#d8417f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    style: {
      stopColor: "#cb3a77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    style: {
      stopColor: "#b92f6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#ae2864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    style: {
      stopColor: "#aa2662"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 271.138,
    cy: 420.279,
    r: 216.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#d8417f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    style: {
      stopColor: "#cb3a77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    style: {
      stopColor: "#b92f6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#ae2864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    style: {
      stopColor: "#aa2662"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 342.487,
    cy: 451.094,
    r: 61.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dcd3ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#dad0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#d2c8e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    style: {
      stopColor: "#c5bad8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    style: {
      stopColor: "#b3a6ca"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    style: {
      stopColor: "#9c8cb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9382b0"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 391.5,
    cy: 981.735,
    r: 61.202,
    gradientTransform: "rotate(30.356 1247.317 535.133)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dcd3ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#dad0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#d2c8e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    style: {
      stopColor: "#c5bad8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    style: {
      stopColor: "#b3a6ca"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    style: {
      stopColor: "#9c8cb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9382b0"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 258.508,
    cy: 296.423,
    r: 94.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#d8417f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    style: {
      stopColor: "#cb3a77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    style: {
      stopColor: "#b92f6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#ae2864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    style: {
      stopColor: "#aa2662"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 323.01,
    cy: 377.427,
    r: 109.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dcd3ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#dad0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#d2c8e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    style: {
      stopColor: "#c5bad8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    style: {
      stopColor: "#b3a6ca"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    style: {
      stopColor: "#9c8cb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9382b0"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 314.416,
    cy: 372.578,
    r: 108.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#d8417f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    style: {
      stopColor: "#cb3a77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    style: {
      stopColor: "#b92f6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#ae2864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    style: {
      stopColor: "#aa2662"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M253.01 353.699v-28.433l34.629-42.986 18.091 52.979-11.465 37.397-24.638 18.014z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m287.639 257.105 38.973 58.011 3.223 30.618-24.105 44.936-29.656 22.744-38.4-45.12 1.294-39.838 18.585-35.562z",
    style: {
      fill: "url(#b)"
    },
    transform: "matrix(.3451 0 0 .26458 -73.814 -64.25)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.3451 0 0 .26458 -73.814 -64.25)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible",
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.421 376.221 337 305.054l-8.986 62.131-53.6 47.497z",
    clipPath: "url(#d)",
    style: {
      opacity: 0.29,
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.338 373.806 115.854-14.617-39.156 49.07-70.256 13.893z",
    clipPath: "url(#d)",
    style: {
      opacity: 0.29,
      fill: "url(#f)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m257.553 292.894-18.585 35.562 14.042-3.19 34.629-42.986v-25.175z",
    style: {
      fill: "url(#g)"
    },
    transform: "matrix(.3451 0 0 .26458 -73.814 -64.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.553 292.894-18.585 35.562 14.042-3.19 34.629-42.986v-25.175z",
    style: {
      opacity: 0.55,
      fill: "url(#h)"
    },
    transform: "matrix(.3451 0 0 .26458 -73.814 -64.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.73 390.67-11.465-18.014 11.465-37.397 24.105 10.475z",
    style: {
      fill: "url(#i)"
    },
    transform: "matrix(.3451 0 0 .26458 -73.814 -64.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.639 282.28c-10.741 14.953-22.051 29.482-33.532 43.869l.311-.844c-.065 3.462-.261 10.423-.384 13.882-.095 3.456-.354 10.425-.508 13.879l-.118-.573a756 756 0 0 1 4.188 9.483c4.156 9.505 8.219 19.041 12.031 28.695-6.489-12.219-12.584-24.625-18.549-37.102l-.122-.258.005-.316.099-6.944c.145-6.185.319-14.642.544-20.824l.015-.479.296-.366c11.612-14.28 23.4-28.424 35.724-42.102",
    style: {
      fill: "#aa4d7b"
    },
    transform: "matrix(.3451 0 0 .26458 -73.814 -64.25)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosa);
export default __webpack_public_path__ + "static/media/rosa.26d226f6ace26435c541202ec09835be.svg";
export { ForwardRef as ReactComponent };